<section>
  <div class="header d-none d-md-block">
    <h1 class="d-inline-flex v-align-middle astral-heading-with-help">
      <span>{{ 'DASHBOARD.MENU.SEND_TENANT_SMS' | translate }}</span>
      <astral-popover [helpText]="'SMS_LIST.HEADER_TOOLTIP'"></astral-popover>
    </h1>
  </div>
  <div class="header d-flex d-md-none align-items-center">
    <h1 class="w-100 astral-heading-with-help">
      <span>{{ 'DASHBOARD.MENU.SEND_TENANT_SMS' | translate }}</span>
      <astral-popover [helpText]="'SMS_LIST.HEADER_TOOLTIP'"></astral-popover>
    </h1>
  </div>
  <div class="row">
    <div class="col-12">
      <app-information-block [text]="'SMS_LIST.HEADER_TOOLTIP' | translate"></app-information-block>
    </div>
  </div>
  <app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
  @if (itemsSource) {
    <app-paged-list-view
      [columnDefinition]="columnDefinition"
      [itemsSource]="itemsSource"
      [contextMenuDefinition]="contextMenuDefinition"
      [menuDefinition]="menuDefinition"
      (rowClick)="onRowClicked($event)"
      [isToolbarSticky]="true"
      (onPageChange)="pagingChanged($event)"
      (onSortChange)="sortChanged($event)"
      [preferencesKey]="preferencesKey"
      [totalCount]="totalResults"
      >
    </app-paged-list-view>
  }
</section>
